require('./cardPayLaterStep2.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ helpers
const { FormattedText, formatText} = require('core/i18n').i18n;
// @ components
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const CardPayLaterInformation = require('components/cards/cardPayLaterSteps/cardPayLaterInformation/cardPayLaterInformation');
// @ constants
const { CARD_PAY_LATER_ID } = require('constants/operationTypes');
// @ helpers
const { nonNumericFilter } = require('utilities/stringHelper');

class CardPayLaterStep2 extends React.Component {

    buildSignatureSection(immCard) {
        return (
            <section className="card-pay-later-step-two__content">
                <SignaturePattern
                    operationType={CARD_PAY_LATER_ID}
                    operationParams={{
                        pan: nonNumericFilter(immCard.get('number'))
                    }}
                />
            </section>
        )
    }

    render() {
        const { immCard, immCardPayLater, immGlobalVariables } = this.props;
        const signatureSection = this.buildSignatureSection(immCard);
        const operativeText = formatText('operatives-payLater');

        return (
            <article className="card-pay-later-step-two">
                <header className="card-pay-later-step-two__header">
                    <FormattedText
                        value="cardPayLater-securityConfirmation"
                        className="card-pay-later-step-two__title"
                    />
                </header>
                <section>
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={operativeText}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        />
                    </ContactCenterRender>
                    <FormattedText
                        className="card-pay-later-step-two__text"
                        value="cardPayLater-confirmationMessage"
                    />
                    <CardPayLaterInformation
                        immCard={immCard}
                        immCardPayLater={immCardPayLater}
                        immGlobalVariables={immGlobalVariables}
                    />
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    {signatureSection}
                </section>
            </article>
        )
    }
}

CardPayLaterStep2.propTypes = {
    immCardPayLater: PropTypes.object,
    immCard: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object
};

module.exports = CardPayLaterStep2;
